module.exports = __webpack_public_path__ + "static/media/LOGO.66701baf.png";